import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ErrorList } from "../../../../../theme/Component/ErrorList";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const SOP003 = ({ configProcedure }: Props) => {

    const { instance, bean, setBean } = useDataBean(_SupplierPaymentOrder);
    const [documents, setDocuments] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);
    const [obs, setObs] = useState<string>("");

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            // setProps(configProcedure?._pocessData?.Props)
            setBean(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {

        if (msgList.length > 0) {
            if (configProcedure?._pushInfo) {
                configProcedure?._pushInfo(msgList[0])
            }

            if (configProcedure?._exportMap) {
                configProcedure?._exportMap({ Response: msgList[0] })
            }
        } else if (msgList.length === 0) {
            if (configProcedure?._pushInfo) {
                configProcedure?._pushInfo(obs)
            }

            if (configProcedure?._exportMap) {
                configProcedure?._exportMap({ Response: obs })
            }
        }



        toast.success(`Se ha enviado la respuesta`)
    }

    const [tap, setTap] = useState<number>(0);

    const GenerarOB = () => {
        instance.createOBForSupplierPaymentOrder(bean.IDSupplierPaymentOrder, bean.SupplierPaymentOrderDate, bean.Consecutive, _single.getAccountID()).then(
            (resp: any) => {
                setDocuments(resp.DocumentURL);
                setMsgList(resp.MsgList);
                setTap(1);
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    return (
        <div className="row">
            {tap === 0 &&
                <>
                    <div className="col-md-12">
                        <label>Consecutivo Externo</label>
                        <input type="number" className="form-control" value={bean.Consecutive} onChange={(e) => { setBean({ ...bean, "Consecutive": e.target.value }) }} />
                    </div>
                    <div className="col-md-12 mt-4">
                        <BasicButton eventClick={GenerarOB} icon="ri-article-line" >Generar Obligaciones</BasicButton>
                    </div>
                </>
            }
            {tap === 1 &&
                <>
                    <div className="col">
                        {msgList.length > 0 &&
                            <ErrorList lista={msgList} />
                        }
                        {msgList.length === 0 && documents.length > 0 &&
                            <>
                                <DocumentViewer key={documents} list={documents} />
                                <div className="col-md-12 mt-2">
                                    <label>Observaciones</label>
                                    <textarea name="Description" className="form-control" rows={5} value={obs} onChange={(e) => { setObs(e.target.value) }} />
                                </div>
                            </>
                        }
                        <div className="col-md-12 mt-4">
                            <BasicButton eventClick={onExportMap} icon="ri-save-line" >{msgList.length > 0 ? "Enviar Observación" : "Adjuntar Obligacion"}</BasicButton>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}